import React, { memo } from "react";
import PrintableSacola from "../../../components/PrintableSacola/PrintableSacola";
import { LayoutImpressaoSacola } from "../../../types/LayoutImpressao";
import "./styles";
import CestasImpressaoContainer from "./styles";

interface CestasImpressaoProps {
  cestas: any;
  layoutConfig?: LayoutImpressaoSacola;
}

const CestasImpressao: React.ForwardRefRenderFunction<
  HTMLDivElement,
  CestasImpressaoProps
> = ({ cestas, layoutConfig }, ref) => {
  return (
    <CestasImpressaoContainer ref={ref}>
      {cestas.map((sacola, index) => (
        <PrintableSacola
          key={index}
          sacola={sacola}
          layoutConfig={layoutConfig}
        />
      ))}
    </CestasImpressaoContainer>
  );
};

export default memo(React.forwardRef(CestasImpressao));
